// export const LOGOUT_OK = state => {
//   state.user = {}
//   state.roles = null
//   state.loggedIn = false
// }

export const getArea = (state, res) => {
  state.areas = res
}

export const areaForm = (state, res) => {
  state.area = res
}

export const areaFormReset = (state, res) => {
  state.area = {
    name: '',
    initials: '',
    area_level_id: 1,
    parent_id: null,
    hybrid: 0
  }
}

export const getAreaLevel = (state, res) => {
  state.areaLevels = res
}

export const formAreaLevel = (state, res) => {
  state.areaLevel = res
}

export const resetFormAreaLevel = state => {
  state.areaLevel = {
    name: ''
  }
}

export const getAreaList = (state, val) => {
  state.areaList = val
}

export const getAllList = (state, val) => {
  state.areaAllList = val
}
